import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';

export type TemplateBuilderTab = 'settings' | 'design' | 'logic';

interface TemplateBuilderTabsProps {
  active: TemplateBuilderTab;
  onChange: (tab: TemplateBuilderTab) => void;
}

const TABS: TemplateBuilderTab[] = ['settings', 'design', 'logic'];

/** Tab navigation for template builder — setup, survey questions, conditional logic. */
export const TemplateBuilderTabs: React.FC<TemplateBuilderTabsProps> = ({ active, onChange }) => {
  const { t } = useLanguage();

  return (
    <div className="tab-bar mb-6">
      <nav className="flex gap-1 overflow-x-auto items-end" aria-label={t('assessmentEngine.builder.tabsLabel')}>
        {TABS.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => onChange(tab)}
            className={`tab-button inline-flex items-center gap-2 ${active === tab ? 'tab-button-selected' : ''}`}
          >
            {t(`assessmentEngine.builder.tab.${tab}`)}
          </button>
        ))}
      </nav>
    </div>
  );
};
